import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import BrandLogo from "./BrandLogo";
import { usePopup } from "../context/PopupContext";

export const Footer = () => {
  const { openPopup } = usePopup();
  return (
    <footer className="relative mt-16 overflow-hidden bg-[#0A2540] text-white" data-testid="site-footer">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 10%, #10B981 0, transparent 40%), radial-gradient(circle at 80% 80%, #3B82F6 0, transparent 45%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-4">
            <BrandLogo variant="light" />
            <p className="mt-4 text-sm text-white/70">
              A specialist agency focused on delivering policy-compliant, beautifully written Wikipedia pages that build lasting credibility for people and brands worldwide.
            </p>
          </div>
          <div className="md:col-span-2">
            <h4 className="mb-4 text-sm font-semibold tracking-wide text-white">Quick Links</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/" className="hover:text-emerald-300">Home</Link></li>
              <li><Link to="/about" className="hover:text-emerald-300">About Us</Link></li>
              <li><Link to="/services" className="hover:text-emerald-300">Services</Link></li>
              <li><Link to="/testimonials" className="hover:text-emerald-300">Testimonials</Link></li>
              <li><Link to="/contact" className="hover:text-emerald-300">Contact Us</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h4 className="mb-4 text-sm font-semibold tracking-wide text-white">Our Services</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/services" className="hover:text-emerald-300">Wiki Creation & Setup</Link></li>
              <li><Link to="/services" className="hover:text-emerald-300">Content Writing & Editing</Link></li>
              <li><Link to="/services" className="hover:text-emerald-300">Compliance & Notability</Link></li>
              <li><Link to="/services" className="hover:text-emerald-300">Wiki Maintenance & Translation</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h4 className="mb-4 text-sm font-semibold tracking-wide text-white">Get in touch</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-3"><Phone className="mt-0.5 h-4 w-4 text-emerald-300" /> +1 (877) 469-1642</li>
              <li className="flex items-start gap-3"><Mail className="mt-0.5 h-4 w-4 text-emerald-300" /> info@Primewikiservices.com</li>
              <li className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 text-emerald-300" /> 360 S Market St, San Jose, CA 95113</li>
            </ul>
            <div className="mt-5 flex gap-2">
              <button onClick={openPopup} className="rounded-full bg-emerald-500 px-4 py-2 text-xs font-semibold text-white hover:bg-emerald-400" data-testid="footer-cta">
                Start My Wiki
              </button>
              <button className="chat inline-flex items-center gap-1 rounded-full border border-white/30 px-4 py-2 text-xs font-semibold text-white hover:bg-white/10" data-testid="footer-chat">
                <MessageCircle className="h-3.5 w-3.5" /> Chat Now
              </button>
            </div>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/60 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Prime Wiki Services. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:text-white" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
